export default {
  state: {
    duration: [15, 30, 45, 60], //会议时长
    pestTypes: [{ //有害生物类别
      value: '昆虫',
      text: '昆虫'
    }, {
      value: '杂草',
      text: '杂草'
    }, {
      value: '线虫',
      text: '线虫'
    }, {
      value: '蟎类',
      text: '蟎类'
    }, {
      value: '真菌',
      text: '真菌'
    }]
  },
  mutations: {
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/vuex/dic.js